<template>
  <v-app-bar class="header">
    <v-img class="d-flex justify-center" src="@/assets/svg/logo.svg"
      alt="株式会社C&Rリーガル･エージェンシー社" />
  </v-app-bar>
</template>
